import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TourService, TourStep } from '../../services/tour.service';

@Component({
  selector: 'app-tour-guide',
  templateUrl: './tour-guide.component.html',
  styleUrls: ['./tour-guide.component.scss']
})
export class TourGuideComponent implements OnInit, OnDestroy {
  @Input() tourSteps: TourStep[] = [];
  @Input() showTourButton: boolean = true;
  @Input() autoStart: boolean = false;

  private autoStartTimeout?: number;

  constructor(private tourService: TourService) { }

  ngOnInit(): void {
    if (this.autoStart && this.tourSteps.length > 0) {
      this.autoStartTimeout = window.setTimeout(() => {
        this.startTour();
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    if (this.autoStartTimeout) {
      clearTimeout(this.autoStartTimeout);
      this.autoStartTimeout = undefined;
    }
  }

  startTour(): void {
    if (this.tourSteps.length > 0) {
      this.tourService.initTour(this.tourSteps);
      this.tourService.start();
    }
  }
}
